import { useActiveScreenNames } from './use-active-screen-names';
import { ScreenName } from '../utils';

type OptionalScreenName = ScreenName | undefined;

/**
 * Returns the current screen name.
 * Supply an optional SSR screen name if desired.
 *
 * ```tsx
 * const currentScreenName = useScreenName();
 * ```
 */
export const useScreenName = (
  ssrScreenName?: ScreenName,
): OptionalScreenName => {
  const defaults = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false,
  };

  if (ssrScreenName) {
    defaults[ssrScreenName] = true;
  }

  const active = useActiveScreenNames(defaults);
  const names = Object.keys(active) as ScreenName[];

  return names.filter(name => active[name]).reverse()[0];
};
